import React from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'redux/hooks';
import { setPartnerMargin, setPartnerWalkinMargin } from '../../../redux/features/CreateDeal';

interface PartnerMarginSectionProps {
  isCalcLoading: boolean;
}

const PartnerMarginSection: React.FC<PartnerMarginSectionProps> = ({
  isCalcLoading
}) => {
  const dispatch = useDispatch();
  const { partner_margin, partner_walkin_margin } = useAppSelector((state) => state.CreateDeal);

  return (
    <div className="max-w-[340px] relative -top-10 space-y-0 w-full flex flex-col gap-3">
      <div className="flex relative flex-col gap-3 items-start justify-start w-full">
        <div className="flex relative flex-col gap-3 items-start justify-start w-full">
          <div className="flex sm:hidden items-center top-0 flex-col after:right-10 after:h-0 absolute after:relative after:content-[''] after:border after:border-dashed">
            <img
              className="relative -left-10"
              src="/images/overview/ellipse.svg"
              alt=""
            />
          </div>
        </div>
        <label htmlFor="partner_margin">My margin</label>
        <input
          value={partner_margin}
          onChange={(e) => {
            if (e.target.value === "") dispatch(setPartnerMargin(""));
            dispatch(setPartnerMargin(e.target.value));
          }}
          disabled={isCalcLoading}
          className="w-full rounded-lg"
          name="partner_margin"
          id="partner_margin"
          type="number"
          placeholder=""
        />
      </div>
      <label htmlFor="partner_walkin_margin">Partner margin</label>
      <input
        value={partner_walkin_margin}
        onChange={(e) => {
          if (e.target.value === "") dispatch(setPartnerWalkinMargin(""));
          dispatch(setPartnerWalkinMargin(e.target.value));
        }}
        disabled={isCalcLoading}
        className="w-full rounded-lg"
        type="number"
        id="partner_walkin_margin"
        name="partner_walkin_margin"
        placeholder=""
      />
    </div>
  );
};

export default PartnerMarginSection;